import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {SecurityService} from '../modules/login/security.service';
import {environment} from '../../environments/environment';

@Injectable()
export class BasicAuthInterceptor implements HttpInterceptor {

    constructor(private authToken: SecurityService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if ( req.url.indexOf('jwt-auth/v1') === -1 && req.url.indexOf('wp/v2') === -1 && req.url.indexOf('wp-json/users') === -1) {
            const authReq = req.clone({
                headers: req.headers.set('Authorization', 'Basic ' + btoa(environment.consumer_key + ':' + environment.consumer_secret))
            });
            return next.handle(authReq);
        }
        // send cloned request with header to the next handler.
        return next.handle(req);
    }
}

